<script lang="ts" setup>
import Alert from '~/components/Alert.vue'

defineProps<{
  successMessage?: string
  errorMessage?: string
}>()
</script>

<template>
  <div v-if="successMessage?.length || errorMessage?.length" class="wl:px-4 wl:pb-4">
    <Alert v-if="successMessage?.length" class="mb-2" success>
      <span v-html="successMessage"></span>
    </Alert>
    <Alert v-if="errorMessage?.length" class="mb-2" danger>
      <span v-html="errorMessage"></span>
    </Alert>
  </div>
</template>

<style scoped lang="postcss"></style>
